import * as React from 'react';

const Create = (props) => (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <title>Create</title>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 .248a.75.75 0 0 1 .745.663l.005.087v5.25H13a.75.75 0 0 1 .088 1.495L13 7.748H7.75v5.25a.75.75 0 0 1-1.495.088l-.005-.088v-5.25H1a.75.75 0 0 1-.087-1.495L1 6.248h5.25V.998A.75.75 0 0 1 7 .248Z"
            fill="#80B8EE"
        />
    </svg>
);

export default Create;
